<template>
  <div>
   <Input ref="user" v-model="value.account" prefix="ios-contact" auto-focus style="margin-top:10px" long placeholder="用户名/手机号" clearable  @on-enter="login">
      <template #prefix>
        <BaseIcon icon="md-contact" size="22" />
      </template>
      </Input>
      <Input :type="showPassword?'':'password'" clearable v-model="value.password" style="margin-top:10px" long placeholder="密码"  @on-enter="login">
      <template #prefix>
        <BaseIcon icon="md-lock" size="22" />
      </template>
      </Input>
      <div class="flex-wrap flex-between"  style="margin-top:10px" v-if="use_vcode">
      <Input clearable v-model="value.vcode" style="flex:1;" long placeholder="图形验证码">
      <template #prefix>
        <BaseIcon icon="md-key" size="22" />
      </template>
      </Input>
      <img :src="`https://api.inbgz.com/public/vcode?t=${vcodeTimestamp}`" ref="vcode" style="flex:0;margin-left:10px;height:100%;background:var(--border);border-radius:5px;width:100px;height:46px;" @click="refreshVcode" />
    </div>

      <Button class="login-btn" style="margin-top:10px" @click="login">登录</Button>
  </div>
</template>

<script>
import crypto from 'crypto';
import BaseIcon from '@components/base/Icon';
export default {
  data() {
    return {
      showPassword: false,
      disabledShowPassword: true,
      use_vcode: false,
      vcodeTimestamp: 0,
    };
  },
  props: {
    value: {
      type: Object,
      default: ()=>({}),
    },
    wechat: {
      type: String,
    },
  },
  components: {BaseIcon},
  actived() {
    this.$nextTick((e)=>{
      if (this.$refs.user) {
        this.$refs.user.focus();
      }
    });
  },
  methods: {
    refreshVcode() {
      this.vcodeTimestamp = Date.now();
    },

    login() {
      const {
        account, password, vcode,
      } = this.value;
      if (!account) {
        this.Error('请输入账号');
        return;
      } else if (!password) {
        this.Error('请输入密码');
        return;
      }
      if (this.use_vcode && !vcode) {
        this.Error('请输入图形验证码');
        return;
      }

      this.$store.dispatch('session/login', {
        account,
        wechat: this.wechat,
        vcode,
        password: crypto.createHash('md5').update(password).digest('hex'),
      }).then((res)=>{
        this.$emit('on-login');
      }).catch((e)=>{
        if (e && e.msg && e.msg.includes('敏感模式')) {
          this.use_vcode = true;
        }
        this.Error(e);
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
